/**
 * Resolve Odoo App Slider `url` into a safe in-app path or external href.
 * Empty / false Odoo chars and javascript: URLs are rejected.
 */

const BLOCKED_PROTOCOLS = /^(javascript|data|vbscript|file):/i;
const TAZEJ_HOSTS = new Set([
    "tazejfood.com",
    "www.tazejfood.com",
    "web.tazejfood.com",
]);

export function normalizeOdooChar(value) {
    if (value == null || value === false) {
        return "";
    }
    return String(value).trim();
}

function hostnameOf(host) {
    return String(host || "").replace(/\.$/, "").toLowerCase();
}

function isTazejHost(host) {
    const name = hostnameOf(host);
    return TAZEJ_HOSTS.has(name);
}

/**
 * @returns {{ type: "internal", path: string, href: string } | { type: "external", href: string } | null}
 */
export function resolveSliderTarget(rawUrl, siteOrigin = "https://www.tazejfood.com") {
    const trimmed = normalizeOdooChar(rawUrl);
    if (!trimmed || BLOCKED_PROTOCOLS.test(trimmed)) {
        return null;
    }

    if (/^\d+$/.test(trimmed)) {
        const path = `/product/${trimmed}`;
        return { type: "internal", path, href: path };
    }

    if (trimmed.startsWith("/")) {
        return { type: "internal", path: trimmed, href: trimmed };
    }

    let candidate = trimmed;
    if (trimmed.startsWith("www.")) {
        candidate = `https://${trimmed}`;
    } else if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed) && trimmed.includes("/")) {
        candidate = trimmed.startsWith("product/") ? `/${trimmed}` : `/${trimmed.replace(/^\/+/, "")}`;
        return { type: "internal", path: candidate, href: candidate };
    }

    try {
        const parsed = new URL(candidate);
        if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
            return null;
        }
        if (isTazejHost(parsed.hostname)) {
            const path = `${parsed.pathname || "/"}${parsed.search || ""}${parsed.hash || ""}`;
            return { type: "internal", path, href: path };
        }
        return { type: "external", href: parsed.href };
    } catch {
        return null;
    }
}
